export default __webpack_public_path__ + "static/media/alba-history-2026.5b04d153.jpg";